export default {
    setEngagementResponse(payload) {
    return payload;
    },
  };
  